import bankInfoAxios from "./bankInfoAxios";

export const getBankStats = () => {
  return bankInfoAxios.get(`/dashboard/stats`)
}

